import { upperFirst } from "lodash";
import moment from "moment";
import ApiService from "./api.service";

export const GET_COMPANY_CLIENT_LIST = "getCompanyClient";
export const GET_COMPANY_CLIENT_SETTINGS = "getSetting";
export const GET_COMPANY_CLIENTS_BY_VENDOR = "getByVendorCompany";
export const GET_COMPANY_CLIENT_DETAIL = "getDetailCompanyClient";
export const CREATE_COMPANY_CLIENT_RECORD = "createCompanyClient";
export const UPDATE_COMPANY_CLIENT_RECORD = "updateCompanyClient";
export const UPDATE_COMPANY_CLIENT_STATUS = "updateStatus";
export const UPDATE_COMPANY_CLIENT_AGREEMENT = "updateAgreement";
export const UPDATE_COMPANY_CLIENT_POLICY = "updatePolicyWps";
export const UPDATE_COMPANY_CLIENT_PARENT = "updateParent";
export const UPDATE_COMPANY_CLIENT_PKS = "updatePks";
export const DELETE_COMPANY_CLIENT_RECORD = "deleteCompanyClient";
export const CREATE_COMPANY_CLIENT_EMPLOYEE_RECORD = "createCompanyClientEmployee";
export const UPDATE_COMPANY_CLIENT_EMPLOYEE_RECORD = "updateCompanyClientEmployee";
export const GET_COMPANY_CLIENT_EMPLOYEE_LIST = "getCompanyClientEmployee";
export const GET_COMPANY_CLIENT_EMPLOYEE_DETAIL = "getDetailCompanyClientEmployee";
export const DELETE_COMPANY_CLIENT_EMPLOYEE_RECORD = "deleteCompanyClientEmployee";
export const IMPORT_COMPANY_CLIENT_EMPLOYEE_BASE64 = "importBase64Employee";
export const IMPORT_COMPANY_CLIENT_EMPLOYEES = "importEmployee";
export const IMPORT_COMPANY_CLIENT_EMPLOYEES_TO_DELETE = "importToDeleteEmployee";

export const GET_COMPANY_CLIENT = GET_COMPANY_CLIENT_LIST;
export const GET_SETTING = GET_COMPANY_CLIENT_SETTINGS;
export const GET_BY_VENDOR_COMPANY = GET_COMPANY_CLIENTS_BY_VENDOR;
export const GET_DETAIL_COMPANY_CLIENT = GET_COMPANY_CLIENT_DETAIL;
export const CREATE_COMPANY_CLIENT = CREATE_COMPANY_CLIENT_RECORD;
export const UPDATE_COMPANY_CLIENT = UPDATE_COMPANY_CLIENT_RECORD;
export const UPDATE_STATUS = UPDATE_COMPANY_CLIENT_STATUS;
export const UPDATE_AGREEMENT = UPDATE_COMPANY_CLIENT_AGREEMENT;
export const UPDATE_POLICY = UPDATE_COMPANY_CLIENT_POLICY;
export const UPDATE_PARENT = UPDATE_COMPANY_CLIENT_PARENT;
export const UPDATE_PKS = UPDATE_COMPANY_CLIENT_PKS;
export const DELETE_COMPANY_CLIENT = DELETE_COMPANY_CLIENT_RECORD;
export const CREATE_COMPANY_CLIENT_EMPLOYEE = CREATE_COMPANY_CLIENT_EMPLOYEE_RECORD;
export const UPDATE_COMPANY_CLIENT_EMPLOYEE = UPDATE_COMPANY_CLIENT_EMPLOYEE_RECORD;
export const GET_COMPANY_CLIENT_EMPLOYEE = GET_COMPANY_CLIENT_EMPLOYEE_LIST;
export const GET_DETAIL_COMPANY_CLIENT_EMPLOYEE = GET_COMPANY_CLIENT_EMPLOYEE_DETAIL;
export const DELETE_COMPANY_CLIENT_EMPLOYEE = DELETE_COMPANY_CLIENT_EMPLOYEE_RECORD;
export const IMPORT_BASE_64_EMPLOYEE = IMPORT_COMPANY_CLIENT_EMPLOYEE_BASE64;
export const IMPORT_EMPLOYEE = IMPORT_COMPANY_CLIENT_EMPLOYEES;
export const IMPORT_TO_DELETE_EMPLOYEE = IMPORT_COMPANY_CLIENT_EMPLOYEES_TO_DELETE;

export const SET_COMPANY_CLIENT = "setCompanyClient";
export const SET_SETTING = "setSetting";
export const SET_BY_VENDOR_COMPANY = "setByVendorCompany";
export const SET_DETAIL_COMPANY_CLIENT = "setDetailCompanyClient";
export const SET_COMPANY_CLIENT_EMPLOYEE = "setCompanyClientEmployee";
export const SET_DETAIL_COMPANY_CLIENT_EMPLOYEE = "setDetailCompanyClientEmployee";

const STATUS_COLOR = {
  waiting_approval: "tag-warning",
  success: "tag-success",
  on_process: "tag-info",
  reject: "tag-danger",
  failed: "tag-danger",
  pending: "tag-info",
  invalid: "tag-warning",
};

const commitList = (context, mutationType, data, transform = (v) => v) => {
  const rows = data.count ? data.rows.map(transform) : [];
  const normalized = { ...data, rows };
  context.commit(mutationType, normalized);
  return normalized;
};

const apiAction = (method, url, payload, { context, mutation, transform } = {}) =>
  new Promise((resolve, reject) => {
    ApiService[method](url, payload)
      .then(({ data }) => {
        const result = mutation ? commitList({ commit: context.commit }, mutation, data.data, transform) : data.data ?? data;
        resolve(result);
      })
      .catch(reject);
  });

const listMutation =
  (stateKey, transform = (v) => v) =>
  (state, data) => {
    try {
      state[stateKey] = {
        ...data,
        rows: data.count ? data.rows.map(transform) : [],
      };
    } catch (error) {
      console.error(`[mutation:${stateKey}]`, error);
    }
  };

const state = {
  company_client: {},
  company_by_vendor: {},
  detail_company_client: {},
  company_client_employee: {},
  company_client_employee_employee: {},
  setting: {},
};

const getters = {
  company_client: (s) => s.company_client,
  company_clients: (s) => s.company_client,
  company_by_vendor: (s) => s.company_by_vendor,
  company_clients_by_vendor: (s) => s.company_by_vendor,
  detail_company_client: (s) => s.detail_company_client,
  company_client_detail: (s) => s.detail_company_client,
  company_client_employee: (s) => s.company_client_employee,
  company_client_employees: (s) => s.company_client_employee,
  company_client_employee_employee: (s) => s.company_client_employee_employee,
  company_client_employee_detail: (s) => s.company_client_employee_employee,
  setting: (s) => s.setting,
  company_client_settings: (s) => s.setting,
};

const actions = {
  [GET_COMPANY_CLIENT_SETTINGS](context, { id, ...query }) {
    return apiAction("get", `api/company-clients/${id}/settings`, query, {
      context,
      mutation: SET_SETTING,
    });
  },

  [GET_COMPANY_CLIENT_LIST](context, param) {
    return apiAction("get", "api/company-clients/list", param, {
      context,
      mutation: SET_COMPANY_CLIENT,
    });
  },

  [GET_COMPANY_CLIENTS_BY_VENDOR](context, { id, ...query }) {
    return apiAction("get", `api/company-clients/vendor/${id}`, query, {
      context,
      mutation: SET_BY_VENDOR_COMPANY,
    });
  },

  [GET_COMPANY_CLIENT_DETAIL](context, param) {
    return apiAction("get", `api/company-clients/${param.id}`, param, {
      context,
      mutation: SET_DETAIL_COMPANY_CLIENT,
    });
  },

  async [CREATE_COMPANY_CLIENT_RECORD](_, param) {
    const { data } = await ApiService.post("api/company-clients", param);
    return data;
  },

  [UPDATE_COMPANY_CLIENT_RECORD](_, { id, ...body }) {
    return ApiService.put(`api/company-clients/${id}`, body);
  },

  [UPDATE_COMPANY_CLIENT_PARENT](_, { id, ...body }) {
    return ApiService.patch(`api/company-clients/${id}/vendor`, body);
  },

  [UPDATE_COMPANY_CLIENT_STATUS](_, { id, status }) {
    return ApiService.patch(`api/company-clients/${id}/status`, { status });
  },

  [UPDATE_COMPANY_CLIENT_AGREEMENT](_, { id, ...body }) {
    return ApiService.patch(`api/company-clients/${id}/settings/agreement`, body);
  },

  [UPDATE_COMPANY_CLIENT_PKS](_, { id, ...body }) {
    return ApiService.patch(`api/company-clients/${id}/pks-date`, body);
  },

  [UPDATE_COMPANY_CLIENT_POLICY](_, { id, ...body }) {
    return ApiService.patch(`api/company-clients/${id}/settings/policy`, body);
  },

  async [DELETE_COMPANY_CLIENT_RECORD](_, { id }) {
    const { data } = await ApiService.delete(`api/company-clients/${id}`);
    return data;
  },

  async [CREATE_COMPANY_CLIENT_EMPLOYEE_RECORD](_, { id, ...payload }) {
    const { data } = await ApiService.post(`api/company-clients/${id}/employees`, payload);
    return data;
  },

  [UPDATE_COMPANY_CLIENT_EMPLOYEE_RECORD](_, { id, employee_id, ...body }) {
    return ApiService.put(`api/company-clients/${id}/employees/${employee_id}`, body);
  },

  [DELETE_COMPANY_CLIENT_EMPLOYEE_RECORD](_, { id, employee_id, ...body }) {
    return ApiService.delete(`api/company-clients/${id}/employees/${employee_id}`, body);
  },

  async [IMPORT_COMPANY_CLIENT_EMPLOYEE_BASE64](_, { id, ...payload }) {
    const { data } = await ApiService.post(`api/company-clients/${id}/employees/import`, payload);
    return data;
  },

  async [IMPORT_COMPANY_CLIENT_EMPLOYEES](_, { id, ...payload }) {
    const { data } = await ApiService.post(`api/company-clients/${id}/employees/import`, payload);
    return data;
  },

  async [IMPORT_COMPANY_CLIENT_EMPLOYEES_TO_DELETE](_, { id, ...payload }) {
    const { data } = await ApiService.post(`api/company-clients/${id}/employees/import-delete`, payload);
    return data;
  },

  [GET_COMPANY_CLIENT_EMPLOYEE_LIST](context, { id, ...query }) {
    return apiAction("get", `api/company-clients/${id}/employees/list`, query, {
      context,
      mutation: SET_COMPANY_CLIENT_EMPLOYEE,
    });
  },

  [GET_COMPANY_CLIENT_EMPLOYEE_DETAIL](context, { id, employee_id, ...param }) {
    return apiAction("get", `api/company-clients/${id}/employees/${employee_id}`, param, {
      context,
      mutation: SET_DETAIL_COMPANY_CLIENT_EMPLOYEE,
    });
  },
};

const mutations = {
  [SET_SETTING]: listMutation("setting"),
  [SET_COMPANY_CLIENT]: listMutation("company_client"),
  [SET_BY_VENDOR_COMPANY]: listMutation("company_by_vendor"),
  [SET_COMPANY_CLIENT_EMPLOYEE]: listMutation("company_client_employee"),
  [SET_DETAIL_COMPANY_CLIENT_EMPLOYEE]: listMutation("company_client_employee_employee"),
  [SET_DETAIL_COMPANY_CLIENT]: listMutation("detail_company_client", (v) => ({
    ...v,
    created_at_str: moment(v.created_at).format("DD MMM YYYY, HH:mm"),
    company_name: v.company.company_name,
    amount_str: `Rp. ${(v.total_amount || 0).toLocaleString()}`,
    status_str: v.status.split("_").map(upperFirst).join(" "),
    status_color: STATUS_COLOR[v.status],
  })),
};

export default {
  state,
  getters,
  actions,
  mutations,
};
